import {GridItem} from 'platform/foundation';
import styled from 'styled-components';

import {isNil} from 'ramda';

import {Nullish, TestIdProps} from 'shared/web';

import {toDashboardGridPlacement} from '../../../utils/toDashboardGridPlacement';

interface DashboardDropIndicatorProps extends TestIdProps {
  row: number | Nullish;
  isTrailing: boolean;
}

const StyledIndicatorTrack = styled.div<{$isTrailing: boolean}>`
  display: flex;
  flex-direction: column;
  justify-content: ${({$isTrailing}) => ($isTrailing ? 'flex-end' : 'flex-start')};
  height: 100%;
`;

const StyledIndicator = styled.div`
  height: ${({theme}) => theme.getSize(1)};
  border-radius: ${({theme}) => theme.radii.circular};
  background: ${({theme}) => theme.colors.general.accent};
  box-shadow: ${({theme}) => theme.shadows.elevation_2};
  pointer-events: none;
  z-index: 2;
`;

export function DashboardDropIndicator(props: DashboardDropIndicatorProps) {
  if (isNil(props.row)) {
    return null;
  }

  const placementRow = props.isTrailing ? props.row - 1 : props.row;

  return (
    <GridItem {...toDashboardGridPlacement({column: 0, row: placementRow, size: 'wide'})}>
      <StyledIndicatorTrack $isTrailing={props.isTrailing}>
        <StyledIndicator data-row={props.row} data-testid={props['data-testid']} />
      </StyledIndicatorTrack>
    </GridItem>
  );
}
